import React from "react";
import { Form, Input, message, Checkbox, Select } from "antd";
import "./CaseNotes.scss";
import Validators from "Common/Validators";
import api from "utils/api";
import Service from "../PHI/Service";
import { connect } from 'react-redux';
import { currentTab } from "store/slice/tabs-slice";
import { setReportFeedBackPublish } from "store/slice/videoConsultation-slice";
import Loader from 'Components/Loader';
import SubmitButton from '../Patient/SubmitButton'
import { CONSTANTS } from "utils/constant";
const placeholder = "Type here...";

const requiredMessage = "This field is required";

class TreatmentPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      update_treatment: false,
      isLoading: false,
      buttonLoading: true,
      is_editable : this.props?.is_editable != undefined ? this.props?.is_editable : true,
    };
    this.form = React.createRef();
  }
  #IsObject(obj) {
    return typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
  }
  componentDidMount() {
    this.getTreatmentConsultation();
    typeof this.props.formAction == "function" && this.props.formAction(false)


  }

  addkeyvalue = (arr) => {
    return arr.reduce((acc, curr) => {
      acc.push({ label: curr.service_name, value: curr.service_name, service_name: curr.service_name, is_selected: curr.is_selected });
      return acc;
    }, []);
  }

  getTreatmentConsultation() {
    this.setState({buttonLoading: false})
    let data = {
      app_id: this.props?.data?.appointment_id,
      type: "case_formulation2",
      isTreatmentplan_filled: false
    };
    api
      .get_consultation_details(data)
      .then(async (response) => {
        let treatment = response.data.data?.results?.case_formulation2;
        if (treatment.length == 0) {
          await this.getTreatmentQuestions();
          return;
        }
        typeof this.props?.visibleEvaluationPublish == "function" && this.props.visibleEvaluationPublish()
        this.setState({
          data: [treatment[0].data],
          recommended_niyama_plan_values:  this.addkeyvalue(treatment[0].data?.evidence_based_treatment_plan?.recommended_niyama_plan.recommended_niyama_plan_values),
          isLoading: false,
          update_diagnosis: true
        });
        let checkBoxList = [
          "psychotherapeutic_values",
          "recommendations_values",
        ];
        let checkboxValues = Service.GetCheckBoxValuesFromData(
          this.state.data,
          checkBoxList
        );
        this.setState((state) => ({
          ...checkboxValues,
        }));
        this.recursiveSearchSet(this.state.data[0], checkBoxList);
        if (this.state.data[0]?.evidence_based_treatment_plan?.recommendations?.recommendations_values?.includes("None")) {
          this.setState({ recommendations_values: { ...this.state.recommendations_values, disabled: true } })
        }
        let res = this.state.recommended_niyama_plan_values.filter((val)=>{if(val.is_selected==true) return val})
        // if (this.state.data[0]?.evidence_based_treatment_plan?.membership_plan_list) {
        //   this.setState({ membership_plan_list: [...this.state.data[0]?.evidence_based_treatment_plan?.membership_plan_list]}

        //     ,()=>{console.log(this.state.membership_plan_list,"memmmbere")})
        // }

        this.form.current?.setFieldsValue(this.state.data[0]);
        this.form.current?.setFieldsValue({
            evidence_based_treatment_plan:{
            recommended_niyama_plan:{recommended_niyama_plan_values:res[0].service_name}}})
            
      })
      .catch(() => { });
  }
  recursiveSearchSet = (data, searchKey, results = {}) => {
    Object.keys(data).forEach((key) => {
      if (searchKey.includes(key)) {
        let output = [];
        for (let x of data[key]) {
          if (x.is_selected) output.push(x.selected_value);
        }
        data[key] = output;
      }
      if (typeof data[key] == "object") {
        this.recursiveSearchSet(data[key], searchKey, results);
      }
    });
  };
  getTreatmentQuestions() {
    this.setState({buttonLoading: false})
    api.get_treatment_questions(this.props?.type || this.props?.data?.user_type).then((res) => {
      let {
        status,
        data: { results },
      } = res.data || {};
      if (status == 200) {
        this.setState({
          data: results,
          recommended_niyama_plan_values: this.addkeyvalue(results[0].data?.evidence_based_treatment_plan?.recommended_niyama_plan.recommended_niyama_plan_values),
          isLoading: false,
        });
        let checkBoxList = [
          "psychotherapeutic_values",
          "recommendations_values",
        ];
        let checkboxValues = Service.GetCheckBoxValuesFromData(
          this.state.data,
          checkBoxList
        );
        this.setState((state) => ({
          ...checkboxValues,
        }));
        // if (this.state.data[0].data?.evidence_based_treatment_plan?.membership_plan_list!==null) {
        //   let memberShipPlan = this.state.data[0].data?.evidence_based_treatment_plan?.membership_plan_list
        //   this.setState({ membership_plan_list: memberShipPlan}
        //     ,()=>{console.log(this.state.membership_plan_list,"memmmbere@@")})
        // }
        // console.log(this.state.membership_plan_list, "membership_plan_list&&")
        this.recursiveSearch(this.state.data, checkBoxList, checkboxValues);
        this.form.current?.setFieldsValue(this.state.data);
        // let newvalue = {
        //   evidence_based_treatment_plan:{membership_plan_list:[{label: 'Ayurvedic Plan', value: 'Ayurvedic Plan', 
        //   is_selected: true}, {label: 'Test Plan', value: 'Test Plan', 
        //   is_selected: false}]}}

        //   let res = newvalue?.evidence_based_treatment_plan?.membership_plan_list.filter((val)=>{if(val.is_selected==true) return val})
        //   console.log(res,"ressssssssss")
        //   Object.keys(newvalue.evidence_based_treatment_plan).map((val)=>{
        //   console.log(val,"KEYS")

        // })

        // this.form.current?.setFieldsValue({
        //   evidence_based_treatment_plan:{membership_plan_list:[{label: 'Ayurvedic Plan', selected_value: 'Ayurvedic Plan', 
        //   is_selected: false}]}})
        // this.form.current?.setFieldsValue({
        //   evidence_based_treatment_plan:{membership_plan_list:res[0].value}})
        
          

      }
    });
  }
  recursiveSearch = (data, searchKey, results = {}) => {
    Object.keys(data).forEach((key) => {
      if (searchKey.includes(key) || {}) {
        data[key] = results[key]?.selected;
      }
      if (this.IsObject(data[key])) {
        this.recursiveSearch(data[key], searchKey, results);
      }
    });
  };

  destructureSelectDropdown(values, recommended_niyama_plan_values) {
    recommended_niyama_plan_values = recommended_niyama_plan_values.map((val) => {
      delete val.label,
      delete val.value
      return val
    })
    if (values !== undefined && values !== null) {
      if (values?.evidence_based_treatment_plan?.recommended_niyama_plan.recommended_niyama_plan_values == "") {
        values.evidence_based_treatment_plan.recommended_niyama_plan.recommended_niyama_plan_values = recommended_niyama_plan_values
      }
      else {
        let key = values?.evidence_based_treatment_plan?.recommended_niyama_plan.recommended_niyama_plan_values
        recommended_niyama_plan_values.map((val) => {
          if (val.service_name == key) {
            val.is_selected = true
          }
          else{
            val.is_selected =false
          }
        })
        values.evidence_based_treatment_plan.recommended_niyama_plan.recommended_niyama_plan_values = recommended_niyama_plan_values
      }
    }

  }
  checkRecursive(result) {
    Object.keys(result).map((key) => {
      if (!this.#IsObject(result[key])) {
        if (result[key]) {
          if (result[key].length > 0) {
            this.setState({ isTreatmentplan_filled: true })
          }
        }
      }
      else { this.checkRecursive(result[key]) }
    })
  }
  onFinish(values) {
    this.setState({buttonLoading: true})
    this.checkRecursive(values)
    
    Object.keys(values.intervention_goals).map((t) => {
      if (values.intervention_goals[t] == undefined)
        values.intervention_goals[t] = "";
    });
    Object.keys(values.evidence_based_treatment_plan).map((t) => {
      if (values.evidence_based_treatment_plan[t] == undefined)
        values.evidence_based_treatment_plan[t] = "";
    });
    let checkBoxList = ["psychotherapeutic_values", "recommendations_values"];
    this.descructurecheckbox(values, checkBoxList, this.state.data);
    this.destructureSelectDropdown(values, this.state.recommended_niyama_plan_values)
    let subvalues = {};
    subvalues.appointment_id = this.props?.data?.appointment_id;
    subvalues.type = this.props?.type || this.props?.data?.user_type;
    subvalues.is_completed = true;
    subvalues.data = values;


    this.state.isTreatmentplan_filled?
    api.treatment_post_answers(subvalues).then((res) => {
      if (res.data?.status == 200) {
        this.props.setReportFeedBackPublish({app_id : this.props?.data?.appointment_id, cf2 : true})
        typeof this.props?.visibleEvaluationPublish == "function" && this.props.visibleEvaluationPublish()
        message.success(res.data?.message, ErrorDuration);
        this.setState({ submittedTreatment: true, form_disable: true, update_diagnosis: true, isLoading: false, buttonLoading: false });
        typeof this.props.formAction == "function" && this.props.formAction(false)
        typeof this.props.updateDrawerData == "function" && this.props.updateDrawerData();
      }
    }):
    <>{message.error("Cannot submit empty form!", ErrorDuration)}
    {this.setState({buttonLoading: false})}
      {typeof this.props.formAction == "function" && this.props.formAction(false)}</>
  }




  IsObject(obj) {
    return typeof obj === "object" && !Array.isArray(obj) && obj !== null;
  }
  descructurecheckbox(data, searchKey, mainkeys, results = {}) {
    Object.keys(data).forEach((key) => {
      if (searchKey.includes(key)) {
        if (this.state[key]) {
          data[key] = this.state[key].options.map((m) => {
            return {
              selected_value: m,
              is_selected: data[key]?.includes(m) ? true : false,
            };
          });
        }
      } else if (this.IsObject(data[key])) {
        this.descructurecheckbox(data[key], searchKey, mainkeys, results);
      }
    });
  }

  render() {
    return (
      <>
        {this.state.isLoading ? <Loader /> :
          <div
            style={this.props.style || {}}
            className="mental-health-examination-container video-casenotes-consultation-wrapper"
          >
            <>
              <Form
                onFinish={this.onFinish.bind(this)}
                onFieldsChange={() => typeof this.props.formAction == "function" && this.props.formAction(true)}
                ref={this.form}
                colon={false}
                labelWrap
                labelAlign="left"
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 14 }}
                requiredMark={false}
                scrollToFirstError={{
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center',
                }}
                className="mhe-form"
              >
                <div className="mhe-form-block">
                  <div className="form-top">
                    <div className="block-1">
                      <b>Intervention Goals</b>
                      <Form.Item
                        name={["intervention_goals", "personal"]}
                        label={Service.RenderFormLabel("Personal")}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        rules={[
                          { required: true, message: requiredMessage },
                          Validators.checkAlphaNumericSpecialCharacters,
                        ]}
                      >
                        <Input.TextArea placeholder={placeholder} />
                      </Form.Item>
                      <Form.Item
                        name={["intervention_goals", "interpersonal"]}
                        label={Service.RenderFormLabel("Interpersonal")}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        rules={[
                          { required: true, message: requiredMessage },
                          Validators.checkAlphaNumericSpecialCharacters,
                        ]}
                      >
                        <Input.TextArea placeholder={placeholder} />
                      </Form.Item>
                      {(this.props?.type == "adolescent" || this.props?.data?.user_type == "adolescent") && (
                        <Form.Item
                          name={["intervention_goals", "academic"]}
                          label={Service.RenderFormLabel("Academic")}
                          labelCol={{ span: 6 }}
                          wrapperCol={{ span: 18 }}
                          rules={[
                            { required: true, message: requiredMessage },
                            Validators.checkAlphaNumericSpecialCharacters,
                          ]}
                        >
                          <Input.TextArea placeholder={placeholder} />
                        </Form.Item>
                      )}
                      {(this.props?.type?.includes("adult") || this?.props?.data?.user_type?.includes("adult") ) && (
                        <Form.Item
                          name={["intervention_goals", "occupational"]}
                          label={Service.RenderFormLabel("Occupational")}
                          labelCol={{ span: 6 }}
                          wrapperCol={{ span: 18 }}
                          rules={[
                            { required: true, message: requiredMessage },
                            Validators.checkAlphaNumericSpecialCharacters,
                          ]}
                        >
                          <Input.TextArea placeholder={placeholder} />
                        </Form.Item>
                      )}
                    </div>
                    <div className="block-2">
                      <b style={{ fontWeight: "bold" }}>
                        Evidence-Based Treatment Plan
                      </b>

                      <Form.Item
                        name={[
                          "evidence_based_treatment_plan",
                          "recommendations",
                          "recommendations_values",
                        ]}
                        label={Service.RenderFormLabel("Recommendations")}
                        rules={[
                          { required: true, message: requiredMessage },
                        ]}
                      >
                        <Checkbox.Group style={{ display: "grid" }}
                          onChange={(value) => {
                            if (value.includes('None')) {
                              this.setState({ recommendations_values: { ...this.state.recommendations_values, disabled: true } })
                              this.form.current?.setFieldsValue({ "evidence_based_treatment_plan": { "recommendations": { "recommendations_values": ['None'] } } })
                            } else {
                              this.setState({ recommendations_values: { ...this.state.recommendations_values, disabled: false } })
                            }
                          }}
                          options={this.state.recommendations_values?.options.map((val) => { return { label: val, value: val, disabled: this.state.recommendations_values?.disabled && val !== 'None' } })}
                        />
                      </Form.Item>

                      <Form.Item
                        name={[
                          "evidence_based_treatment_plan",
                          "psychotherapeutic",
                          "psychotherapeutic_values",
                        ]}
                        label="Psychotherapeutic"
                      >
                        <Checkbox.Group style={{ display: "grid" }}
                          onChange={(values) => {
                            let options = [
                              ...this.state.psychotherapeutic_values?.options,
                            ];
                            this.setState({
                              psychotherapeutic_values: {
                                ...this.state.psychotherapeutic_values,
                                options: options,
                              },
                            });
                          }}
                          options={this.state.psychotherapeutic_values?.options}
                        />
                      </Form.Item>

                      <Form.Item
                        name={["evidence_based_treatment_plan", "pharmacological"]}
                        label="Pharmacological"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 18 }}
                        rules={[
                          {},
                          Validators.checkAlphaNumericSpecialCharacters,
                        ]}
                      >
                        <Input.TextArea placeholder={placeholder} />
                      </Form.Item>
                      <Form.Item
                        name={["evidence_based_treatment_plan", "ayurveda"]}
                        label="Ayurveda"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 18 }}
                        rules={[
                          {},
                          Validators.checkAlphaNumericSpecialCharacters,
                        ]}
                      >
                        <Input.TextArea placeholder={placeholder} />
                      </Form.Item>

                      <Form.Item
                        name={[
                          "evidence_based_treatment_plan",
                          "recommended_niyama_plan",
                          "recommended_niyama_plan_values",
                        ]}
                        labelCol={{ span: 8 }}
                        // wrapperCol={{ span: 18 }}
                        label="Recommended Niyama Plan"
                      >
                        <Select allowClear placeholder="Select" options={this.state.recommended_niyama_plan_values}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        popupClassName="treatment-plan-dropdown"
                        ></Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </Form>
              {this.state.is_editable &&
              <div className="submit-button-wrapper-drawerMse">
              {(this.props.isEvaluationPublish || this.props.publishClicked) ? null :
              <SubmitButton label={!this.state.update_diagnosis ? `${CONSTANTS.SUBMIT}` : `${CONSTANTS.UPDATE}`} className={"common-btn"} onClick={(e) => this.form.current?.submit()} loading={this.state.buttonLoading}/>
              }
              </div>}
            </>
          </div>
        }
      </>
    );
  }
}
const mapDispatchToProps = {
  currentTab,
  setReportFeedBackPublish
}
export default connect(null, mapDispatchToProps)(TreatmentPlan);
